module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "action-select",
    class: [_vm.ready ? 'is-visible' : 'is-hidden']
  }, [_c('p', [_vm._v("Was möchten Sie tun?")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "Länderporträt anschauen",
      "name": "grp",
      "action": "showView",
      "value": "portrait",
      "checked": "checked"
    }
  }), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "Länder nach Kennzahlen vergleichen",
      "name": "grp",
      "action": "showView",
      "value": "comparison"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex content",
    class: [_vm.ready ? 'is-visible' : 'is-hidden']
  }, [_c('div', {
    staticClass: "widget",
    class: [_vm.infoView === 'portrait' ? 'extra-margin' : '']
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "wrapper map"
  }, [_c('Map', {
    attrs: {
      "countries": _vm.countries,
      "selectedCountry": _vm.selectedCountry,
      "view": _vm.infoView
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper filter"
  }, [_c('ul', {
    staticClass: "list",
    class: [_vm.infoView === 'portrait' ? 'hide-s' : '']
  }, [_vm._l((_vm.filter), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('RadioButton', {
      attrs: {
        "id": item.label,
        "isDisabled": _vm.filterDisabled,
        "action": "setFilter",
        "value": index,
        "name": "grp-type"
      }
    })], 1)
  }), _vm._v(" "), _c('li', [_c('CheckBox', {
    staticClass: "hide-s",
    attrs: {
      "id": "Alle Länder auswählen",
      "name": "grp-all",
      "isDisabled": _vm.filterDisabled,
      "checked": _vm.allCountriesSelected,
      "action": "selectAllCountries"
    }
  })], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "wrapper info"
  }, [_c('Info', {
    attrs: {
      "selectedCountry": _vm.selectedCountry,
      "all": _vm.countries,
      "countries": _vm.selectedCountries,
      "view": _vm.infoView,
      "filter": _vm.filter,
      "curFilter": _vm.curFilter,
      "columns": _vm.columns
    }
  })], 1)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Overlays')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Die Euroländer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "href": "#impressum"
    }
  }, [_vm._v("IMPRESSUM")]), _vm._v(" "), _c('div', {
    staticClass: "icon-logo"
  }, [_vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4726507c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 567
// module chunks = 0